export const ORDER = 'ORDER';
export const GET_COMPLETED_ORDER_REQUEST = `${ORDER}/getCompletedOrdersRequest`;
export const UPDATE_ORDER_STATUS_REQUEST = `${ORDER}/updateOrderStatusRequest`;
